import { ITranslationEntry } from '../lang';

export const FA: ITranslationEntry = {
  translations: {
    notifications: 'اطلاعیه',
    markAllAsRead: 'همه را به عنوان خوانده شده علامت بزن',
    poweredBy: 'پشتیبانی شده توسط',
    settings: 'تنظيمات',
  },
  lang: 'fa',
};
